<template><router-view /></template>

<script>
export default { name: 'RouteView' }
</script>



// WEBPACK FOOTER //
// src/views/layout/RouteView.vue